export type ErrorModalClose = Action<'ERROR_MODAL_CLOSE'>;

export const errorModalClose = () => ({
  type: 'ERROR_MODAL_CLOSE'
});
